import {
  CancelableQueryViewArgs,
  query,
  Query,
  QueryHandlerFunction,
  QueryHandlerFunctionArgs,
} from "@lookiero/messaging";

const VIEW_IS_COMPLETE_YOUR_LOOK_OFFFERING_ENABLED = "view_is_complete_your_look_offfering_enabled";

interface ViewIsCompleteYourLookOfferingEnabled extends Query<typeof VIEW_IS_COMPLETE_YOUR_LOOK_OFFFERING_ENABLED> {}

interface ViewIsCompleteYourLookOfferingEnabledFunction {
  (): ViewIsCompleteYourLookOfferingEnabled;
}

const viewIsCompleteYourLookOfferingEnabled: ViewIsCompleteYourLookOfferingEnabledFunction = () =>
  query({ name: VIEW_IS_COMPLETE_YOUR_LOOK_OFFFERING_ENABLED });

type ViewIsCompleteYourLookOfferingEnabledResult = boolean;

interface IsCompleteYourLookOfferingEnabledViewArgs extends CancelableQueryViewArgs {}

interface IsCompleteYourLookOfferingEnabledView {
  (args: IsCompleteYourLookOfferingEnabledViewArgs): Promise<ViewIsCompleteYourLookOfferingEnabledResult>;
}

interface ViewIsCompleteYourLookOfferingEnabledHandlerFunctionArgs extends QueryHandlerFunctionArgs {
  readonly view: IsCompleteYourLookOfferingEnabledView;
}

const viewIsCompleteYourLookOfferingEnabledHandler: QueryHandlerFunction<
  ViewIsCompleteYourLookOfferingEnabled,
  ViewIsCompleteYourLookOfferingEnabledResult,
  ViewIsCompleteYourLookOfferingEnabledHandlerFunctionArgs
> =
  ({ view, signal }) =>
  async () =>
    view({ signal });

export type { IsCompleteYourLookOfferingEnabledView, ViewIsCompleteYourLookOfferingEnabledResult };
export {
  VIEW_IS_COMPLETE_YOUR_LOOK_OFFFERING_ENABLED,
  viewIsCompleteYourLookOfferingEnabled,
  viewIsCompleteYourLookOfferingEnabledHandler,
};
